import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  Button,
  MenuItem,
  MenuList,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  MenuButton,
  Image,
  HStack,
  Img,
  useDisclosure,
  Skeleton,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import { AiOutlineMore } from "react-icons/ai";
import iconEdit from "../../assets/images/employee/edit.svg";
import detail from "../../assets/images/employee/detail.svg";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import ReactPaginate from "react-paginate";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import FormJobTitleDetail from "./popupForm/formJobTitleDetail";
import FormJobTitleEdit from "./popupForm/formJobTitleEdit";
import FormJobTitleCreate from "./popupForm/formJobTitleCreate";
import { usePopupFormJobTitle } from "../../contexts/usePopupJobTitle";
import { useCategories } from "../../categorys/jobTitle/index";
import SearchableSelect from "../../components/selectForm";
import SearchableSelectMulti from "../../components/selectForm/mutiSelect";
import useDebounce from "../../hooks/useDebounce";
import DatePicker from "react-datepicker";
import toast from "react-hot-toast";
import { attendanceCall } from "../../api/attendance";
import { useSelector } from "react-redux";
import { EMPLOYEE_DEPARTMENT } from "../../utils/contants";

const TableJobTitle = ({
  paramData,
  attendanceData,
  refetch,
  isLoading,
  isRefetching,
  totalPages,
  setCurrentPage,
  currentPage,
  entries,
  startEntry,
  endEntry,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { popupFormContextVisible, setPopupFormContextVisible } =
    usePopupFormJobTitle();

  const [isCreateMode, setIsCreateMode] = useState(false);

  // Chỉ Ban giám đốc được mở chỉnh sửa bản ghi đã chốt công
  const user = useSelector((state) => state.auth.login?.currentUser);
  const isManager = user?.user?.department === EMPLOYEE_DEPARTMENT.MANAGER;

  // -------- filters --------
  const [dataEdit, setDataEdit] = useState({});
  const [dataDetail, setDataDetail] = useState({});
  const [saleBlock, setSaleBlock] = useState(null);
  const [saleArea, setSaleArea] = useState(null);
  const [department, setDepartment] = useState(null);
  const [supportDepartmentsId, setSupportDepartmentsId] = useState(null);
  const [branchesId, setBranchesId] = useState(null);
  const [businessCategoryIds, setBusinessCategoryIds] = useState([]);
  const [employeeStatus, setEmployeeStatus] = useState(null);
  const [date, setDate] = useState(null);

  // search
  const [search, setSearch] = useState("");
  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  }, []);
  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(() => {
    paramData?.({
      search: debouncedSearchTerm,
      saleAreaId: saleArea,
      saleBlockId: saleBlock,
      department,
      supportDepartmentsId,
      branchesId,
      businessCategoryIds,
      status: employeeStatus,
      date,
    });
  }, [
    saleArea,
    saleBlock,
    department,
    supportDepartmentsId,
    branchesId,
    businessCategoryIds,
    employeeStatus,
    debouncedSearchTerm,
    date,
    paramData,
  ]);

  const handlePageChange = (selectedPage) => {
    setCurrentPage?.(selectedPage.selected + 1);
    refetch?.();
  };

  const tableData = {
    headers: [
      { label: "", key: "" },
      { label: "Thời gian", key: "date" },
      { label: "Mã nhân viên", key: "codeEmployee" },
      { label: "Tên nhân viên", key: "fullName" },
      { label: "Khối", key: "saleBlock" },
      { label: "Vùng", key: "saleArea" },
      { label: "Phòng ban", key: "supportDepartment" },
      { label: "Chức vụ", key: "jobPosition" },
      { label: "Tỉ lệ phí dịch vụ", key: "commissionRate" },
      { label: "Ngày công", key: "workingDays" },
      { label: "Phân loại", key: "businessCategory" },
      { label: "CCCD/CMND", key: "identificationNumber" },
      { label: "Stk&Ngân hàng", key: "bankInfo" },
      { label: "Số ngày chấm công", key: "totalStandardWorking" },
      { label: "Mã người giới thiệu", key: "referralCode" },
      { label: "Tên người giới thiệu", key: "referralName" },
      { label: "Khối người giới thiệu", key: "referralBlock" },
      { label: "Vùng người giới thiệu", key: "referralArea" },
      { label: "Trưởng vùng", key: "saleAreaManager" },
      { label: "Trưởng khối", key: "saleBlockManager" },
      { label: "Trưởng phòng", key: "supportDepartmentManager" },
      { label: "Chốt công", key: "lockStatus" },
    ],
    data: attendanceData,
  };

  const handleChange = (update) => {
    setDate(update);
  };

  const handleDetail = (data) => {
    setPopupFormContextVisible(false);
    setIsCreateMode(false);
    setDataDetail(data);
    onOpen();
  };

  const handleEdit = (data) => {
    setPopupFormContextVisible(true);
    setIsCreateMode(false);
    setDataEdit(data);
    onOpen();
  };

  const handleUnlock = async (data) => {
    const toastUnlock = toast.loading("Đang mở chỉnh sửa ...");

    try {
      await attendanceCall.unlock(data?.dataEdit?.id);
      await refetch?.();
      toast.success(
        "Đã mở chỉnh sửa. Lưu chỉnh sửa xong bản ghi sẽ tự khoá lại",
      );
    } catch (error) {
      console.error("Unlock error:", error);
    } finally {
      toast.dismiss(toastUnlock);
    }
  };

  const handleOpenCreate = () => {
    setPopupFormContextVisible(true);
    setIsCreateMode(true);
    setDataEdit({});
    setDataDetail({});
    onOpen();
  };

  const { constantData } = useCategories(saleArea);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({
      key,
      value:
        typeof value === "object"
          ? value.fullName || JSON.stringify(value)
          : value,
    }));

  const saleAreas = useMemo(
    () => formatEntries(constantData?.saleAreas),
    [constantData?.saleAreas],
  );
  const saleBlocks = useMemo(
    () => formatEntries(constantData?.saleBlocks),
    [constantData?.saleBlocks],
  );
  const departments = useMemo(
    () => formatEntries(constantData?.departmentByNumbers),
    [constantData?.departmentByNumbers],
  );
  const supportDepartments = useMemo(
    () => formatEntries(constantData?.supportDepartments),
    [constantData?.supportDepartments],
  );
  const branches = useMemo(
    () => formatEntries(constantData?.branches),
    [constantData?.branches],
  );
  const businessCategories = useMemo(() => {
    const fromAPI = formatEntries(constantData?.businessCategories);
    return [
      ...fromAPI,
      {
        key: "elite_fulltime",
        value: "Đi làm fulltime thực tế",
      },
    ];
  }, [constantData?.businessCategories]);

  // Trạng thái nhân viên (key dạng chuỗi để "0" vẫn được coi là đã chọn)
  const employeeStatuses = [
    { key: "0", value: "Đang làm việc" },
    { key: "1", value: "Đã nghỉ việc" },
  ];

  const defaultCreateValues = useMemo(() => {
    const currentDate = date ? new Date(date) : new Date();

    return {
      employeeId: "",
      month: currentDate.getMonth() + 1,
      year: currentDate.getFullYear(),
      department: "",
      workingDays: "",
      totalStandardWorking: "",
      businessCategoryId: "",
      jobPositionId: "",
      commissionRate: "",
      supportDepartmentId: "",
      supportDepartmentManagerId: "",
      saleAreaId: "",
      saleBlockId: "",
      saleAreaManagerId: "",
      saleBlockManagerId: "",
      branchId: "",
      branchManagerId: "",
    };
  }, [date]);

  const handleUpdate = async (data) => {
    const toastEdit = toast.loading("Đang sửa dữ liệu ...");

    try {
      const submitData = { ...data };
      delete submitData?.department;

      const cleanedData = Object.fromEntries(
        Object.entries(submitData).filter(([_, value]) => value !== ""),
      );

      const { id, ...dataEditSubmit } = cleanedData;

      await attendanceCall.update(id, dataEditSubmit);
      await refetch?.();
      onClose();
      toast.success("Sửa thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi sửa");
    } finally {
      toast.dismiss(toastEdit);
    }
  };

  const handleCreate = async (data) => {
    const toastCreate = toast.loading("Đang thêm dữ liệu ...");

    try {
      const submitData = { ...data };
      delete submitData?.department;

      const cleanedData = Object.fromEntries(
        Object.entries(submitData).filter(
          ([_, value]) => value !== "" && value !== null && value !== undefined,
        ),
      );

      await attendanceCall.create(cleanedData);
      await refetch?.();
      onClose();
      toast.success("Thêm thành công");
    } catch (error) {
      console.error("Create error:", error);
      toast.error("Có lỗi xảy ra khi thêm");
    } finally {
      toast.dismiss(toastCreate);
    }
  };

  return (
    <Flex flexDirection={"column"} gap={{ base: "16px" }}>
      <Flex
        backgroundColor="var(--color-main)"
        borderRadius={{ base: "12px" }}
        flexDirection={"column"}
      >
        <Flex
          alignItems={"flex-start"}
          gap={{ base: "16px 32px" }}
          flex={"1"}
          flexDirection={"column"}
          p={"16px 16px 12px 16px"}
        >
          <Flex
            w={"100%"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"16px"}
            flexWrap={"wrap"}
          >
            <InputGroup
              maxW="42vw"
              minW={{ base: "100%", lg: "42vw" }}
              borderRadius={{ base: "8px" }}
              w={{ base: "100%" }}
            >
              <Input
                placeholder="Nhập MVN, họ tên, sđt..."
                type="text"
                borderRadius={{ base: "8px" }}
                border={{ base: "1px solid var(--color-secondary)" }}
                onChange={onChangeSearch}
              />
              <InputRightElement
                borderTopRightRadius={"8px"}
                borderBottomRightRadius={"8px"}
                pointerEvents="none"
                backgroundImage="var(--color-button)"
              >
                <SearchIcon color="var(--color-main)" />
              </InputRightElement>
            </InputGroup>

            <Button
              minW={"140px"}
              h={"44px"}
              px={"16px"}
              fontSize={"15px"}
              fontWeight={600}
              color={"var(--color-main)"}
              bg="var(--linear-gradient-employee)"
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={handleOpenCreate}
            >
              Thêm mới
            </Button>
          </Flex>

          <Flex
            alignItems={"center"}
            gap={{ base: "16px 32px" }}
            flex={"1"}
            flexWrap={"wrap"}
            w={"100%"}
          >
            <InputGroup maxW={"255px"} zIndex={3}>
              <DatePicker
                selected={date}
                onChange={handleChange}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                isClearable={true}
                placeholderText="Tháng năm"
                className="datePickerStyle"
                locale="vi"
              />
              {!date && (
                <InputRightElement pointerEvents="none" h={"44px"}>
                  <Image src={calendarIcon} />
                </InputRightElement>
              )}
            </InputGroup>

            <SearchableSelect
              isShowSearch={true}
              options={saleAreas}
              initialSelectedOption={{ key: 0, value: "Chọn vùng" }}
              setValue={setSaleArea}
            />
            <SearchableSelect
              isShowSearch={true}
              options={saleBlocks}
              initialSelectedOption={{ key: 0, value: "Chọn khối" }}
              setValue={setSaleBlock}
            />
            <SearchableSelect
              isShowSearch={false}
              options={departments}
              initialSelectedOption={{ key: 0, value: "Loại nhân viên" }}
              setValue={setDepartment}
            />
            <SearchableSelect
              isShowSearch={false}
              options={supportDepartments}
              initialSelectedOption={{ key: 0, value: "Chọn phòng ban" }}
              setValue={setSupportDepartmentsId}
            />
            <SearchableSelect
              isShowSearch={false}
              options={branches}
              initialSelectedOption={{ key: 0, value: "Chọn chi nhánh" }}
              setValue={setBranchesId}
            />
            <SearchableSelect
              isShowSearch={false}
              options={employeeStatuses}
              initialSelectedOption={{ key: null, value: "Trạng thái nhân viên" }}
              setValue={setEmployeeStatus}
            />
            <SearchableSelectMulti
              isShowSearch={true}
              options={businessCategories}
              placeholder="Phân loại"
              setValue={setBusinessCategoryIds}
            />
          </Flex>
        </Flex>

        <Box width={"100%"} height={"100%"}>
          <Skeleton isLoaded={!isLoading && !isRefetching}>
            <TableContainer
              w={"100%"}
              maxH="calc(100vh - 350.5px)"
              overflowY="auto"
            >
              <Table w={"100%"} variant="unstyled">
                <Thead
                  position="sticky"
                  top="0"
                  zIndex="1"
                  w={"100%"}
                  h={"41px"}
                  color="white"
                  fontWeight="400"
                  backgroundColor="#F9FAFD"
                >
                  <Tr h={{ base: "41px" }}>
                    {tableData.headers.map((e, index) => {
                      let width = "auto";
                      let textAlign = "auto";

                      if (e.key === "") {
                        width = "2%";
                        textAlign = "center";
                      } else if (e.key === "date") {
                        width = "5%";
                        textAlign = "start";
                      } else if (
                        e.key === "codeEmployee" ||
                        e.key === "fullName" ||
                        e.key === "saleBlock" ||
                        e.key === "saleArea" ||
                        e.key === "supportDepartment"
                      ) {
                        width = "10%";
                        textAlign = "start";
                      } else if (e.key === "jobPosition") {
                        width = "10%";
                        textAlign = "center";
                      } else {
                        width = "10%";
                        textAlign = "end";
                      }

                      return (
                        <Td
                          p={"16px 16px 8px 16px"}
                          key={index}
                          border={"none"}
                          color={"#51607B"}
                          fontSize={{ base: "14px" }}
                          w={width}
                        >
                          <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                        </Td>
                      );
                    })}
                  </Tr>
                </Thead>

                <Tbody w={"100%"} h={"100%"}>
                  {tableData.data?.length > 0 ? (
                    tableData.data?.map((e, rowIndex) => {
                      const items = { ...e };
                      delete items.idEmployee;
                      delete items.month;
                      delete items.year;
                      delete items.dataEdit;
                      delete items.department;
                      delete items.export;
                      delete items.isLocked;

                      const keyValues = Object.keys(items);

                      return (
                        <Tr key={rowIndex} h={"72px"}>
                          <Td
                            p={"16px 16px 8px 16px"}
                            w={rowIndex === 0 ? "20px" : "auto"}
                          >
                            <Menu>
                              <MenuButton
                                _hover={{ backgroundColor: "none" }}
                                _active={{ backgroundColor: "none" }}
                                background="none"
                                as={Button}
                              >
                                <AiOutlineMore fontSize={"20px"} />
                              </MenuButton>

                              <MenuList
                                fontSize={{ base: "14px" }}
                                fontWeight={500}
                                lineHeight={"140%"}
                                color={"#293755"}
                              >
                                <MenuItem
                                  gap={"16px"}
                                  fontWeight={500}
                                  fontSize={{ base: "14px" }}
                                  onClick={() => handleDetail(e)}
                                >
                                  <Image src={detail} /> Xem chi tiết
                                </MenuItem>
                                {!e.isLocked && (
                                  <MenuItem
                                    gap={"16px"}
                                    fontWeight={500}
                                    fontSize={{ base: "14px" }}
                                    onClick={() => handleEdit(e)}
                                  >
                                    <Image src={iconEdit} /> Chỉnh sửa
                                  </MenuItem>
                                )}
                                {e.isLocked && isManager && (
                                  <MenuItem
                                    gap={"16px"}
                                    fontWeight={500}
                                    fontSize={{ base: "14px" }}
                                    onClick={() => handleUnlock(e)}
                                  >
                                    <Image src={iconEdit} /> Mở chỉnh sửa
                                  </MenuItem>
                                )}
                              </MenuList>
                            </Menu>
                          </Td>

                          {keyValues.map((keyvalue, index) => {
                            let width = "auto";
                            let textAlign = "auto";

                            if (keyvalue === "date") {
                              width = "5%";
                              textAlign = "start";
                            } else if (
                              keyvalue === "codeEmployee" ||
                              keyvalue === "fullName" ||
                              keyvalue === "saleBlock" ||
                              keyvalue === "saleArea" ||
                              keyvalue === "supportDepartment"
                            ) {
                              width = "10%";
                              textAlign = "start";
                            } else if (keyvalue === "jobPosition") {
                              width = "10%";
                              textAlign = "center";
                            } else {
                              width = "10%";
                              textAlign = "end";
                            }

                            return (
                              <Td
                                p={"16px 16px 8px 16px"}
                                w={width}
                                key={index}
                              >
                                <Box
                                  fontSize={{ base: "14px" }}
                                  textAlign={"start"}
                                  fontWeight={500}
                                  color={"#293755"}
                                  h={"140%"}
                                >
                                  {formatTableValue(e[keyvalue], keyvalue)}
                                </Box>
                              </Td>
                            );
                          })}
                        </Tr>
                      );
                    })
                  ) : (
                    <Tr>
                      <Td
                        colSpan={tableData.headers.length}
                        textAlign="center"
                        padding={"40px 0"}
                      >
                        Không có dữ liệu
                      </Td>
                    </Tr>
                  )}
                </Tbody>
              </Table>
            </TableContainer>
          </Skeleton>

          <Box mt={10} mr={5} mb={5} ml={5}>
            <Flex alignItems={"center"} justifyContent={"space-between"}>
              <Text>
                Showing {startEntry} to {endEntry} of {entries} entries
              </Text>

              <HStack spacing={2} justify="flex-end">
                <ReactPaginate
                  className="pagination-custom"
                  pageCount={totalPages}
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={1}
                  onPageChange={handlePageChange}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  breakClassName={"ellipsis"}
                  breakLabel={"..."}
                  previousLabel={
                    <Img
                      w={"16px"}
                      minW={"16px"}
                      h={"16px"}
                      src={chevronLeft}
                    />
                  }
                  nextLabel={
                    <Img
                      w={"16px"}
                      minW={"16px"}
                      h={"16px"}
                      src={chevronRight}
                    />
                  }
                  renderOnZeroPageCount={null}
                  forcePage={(currentPage || 1) - 1}
                />
              </HStack>
            </Flex>
          </Box>
        </Box>
      </Flex>

      {!popupFormContextVisible && (
        <FormJobTitleDetail
          edit={false}
          isOpen={isOpen}
          onClose={onClose}
          dataDetail={dataDetail}
        />
      )}

      {popupFormContextVisible && isCreateMode && (
        <FormJobTitleCreate
          isOpen={isOpen}
          onClose={onClose}
          defaultValues={defaultCreateValues}
          onSubmit={handleCreate}
        />
      )}

      {popupFormContextVisible && !isCreateMode && (
        <FormJobTitleEdit
          edit={true}
          isOpen={isOpen}
          onClose={onClose}
          dataEdit={dataEdit?.dataEdit}
          defaultValues={dataEdit?.dataEdit || {}}
          onSubmit={handleUpdate}
        />
      )}
    </Flex>
  );
};

export default TableJobTitle;
